module.exports = __webpack_public_path__ + "static/media/tick.2d2cfe3c.svg";